import { render, staticRenderFns } from "./addReportCustomComponentFooter.vue?vue&type=template&id=4e45bd12"
import script from "./addReportCustomComponentFooter.vue?vue&type=script&lang=js"
export * from "./addReportCustomComponentFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports